import { createRoutine } from 'redux-saga-routines';
import { GET_ARTICLES, GET_ARTICLES_AGGREGATIONS } from './constants';

export const getArticles = createRoutine(GET_ARTICLES);
export const getArticlesAggregations = createRoutine(GET_ARTICLES_AGGREGATIONS);
